import React, { ChangeEvent, useEffect, useState } from 'react'

import Typography from '@mui/material/Typography'
import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Switch,
    Tab,
    TextField,
} from '@mui/material'
import Cancel from './../../../../../assets/icons/close.png'

function SpecificationPreview(props) {
    const handleClose = () => {
        props.onHandleAddItem(false)

    }


    const previewData = [
        {
            id: 1, section: 'Sauces', sectionId: 1, items: [
                { id: 1, itemName: "Tomato Sauce", price: "5$", ischeck: false },
                { id: 2, itemName: "Barbecue Sauce", price: "6$", ischeck: false },
                { id: 3, itemName: "Mustard Sauce", price: "10$", ischeck: false },
                { id: 4, itemName: "Tamarind Sauce", price: "5$", ischeck: false },
                { id: 5, itemName: "Chili Sauce", price: "6$", ischeck: false },
                { id: 6, itemName: "Olive Sauce", price: "10$", ischeck: false },
                { id: 7, itemName: "Garlic sauce", price: "5$", ischeck: false },
            ]
        },
        {
            id: 2, section: 'Portion size', sectionId: 2, items: [
                { id: 1, itemName: "Half", price: "10$", ischeck: false },
                { id: 2, itemName: "Three quarter", price: "6$", ischeck: false },
                { id: 3, itemName: "Full", price: "10$", ischeck: false }
            ]
        },
        {
            id: 3, section: 'Sauces', sectionId: 3, items: [
                { id: 1, itemName: "Tomato Sauce", price: "5$", ischeck: false },
                { id: 2, itemName: "Barbecue Sauce", price: "6$", ischeck: false },
                { id: 3, itemName: "Mustard Sauce", price: "10$", ischeck: false },
                { id: 4, itemName: "Tamarind Sauce", price: "5$", ischeck: false },
                { id: 5, itemName: "Chili Sauce", price: "6$", ischeck: false },
                { id: 6, itemName: "Olive Sauce", price: "10$", ischeck: false },
                { id: 7, itemName: "Garlic sauce", price: "5$", ischeck: false },
            ]
        },
        {
            id: 4, section: 'Portion size', sectionId: 4, items: [
                { id: 1, itemName: "Half", price: "10$", ischeck: false },
                { id: 2, itemName: "Three quarter", price: "6$", ischeck: false },
                { id: 3, itemName: "Full", price: "10$", ischeck: false }
            ]
        }
    ]
    const [dataArr, setDataArr] = useState({});
    useEffect(() => {
        console.log("props: " + props.data.id);
        let data = previewData.find(x => x.sectionId === props.data.id);
        console.log("data: " + data);
        setDataArr(data);
    })

    return (
        <React.Fragment>
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={props.open}
                onClose={handleClose}
            >
                <Grid container>
                    <Grid item xs={6}>
                        <DialogTitle>Preview - {props.data.section}</DialogTitle>
                    </Grid>
                    <Grid item xs={6}>
                        <DialogActions>
                            <Button onClick={handleClose}>
                                <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                            </Button>
                        </DialogActions>
                    </Grid>
                </Grid>
                <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
                    <div>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={12}>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th>
                                                Item Name
                                            </th>
                                            <th>
                                                Price
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            dataArr != undefined ? (
                                                dataArr.items?.map((d, index) => {
                                                    return (
                                                        <tr key={index}>

                                                            <td>
                                                                {d.itemName}
                                                            </td>
                                                            <td>
                                                                {d.price}
                                                            </td>


                                                        </tr>
                                                    )
                                                })) : ""

                                        }
                                        <tr>

                                        </tr>
                                    </tbody>
                                </table>
                            </Grid>

                        </Grid>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={9}></Grid>
                            <Grid item xs={2}>
                                <Button className="AddItemButtons" onClick={handleClose}>
                                    Close
                                </Button>
                            </Grid>
                        </Grid>

                    </div>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}

export default SpecificationPreview;